module.exports = __webpack_public_path__ + "img/Icon_Carga_Certificaciones_Masa.efd2e70d.svg";